module.exports = __webpack_public_path__ + "d55db9082545c713d306079c13de17cd.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/sound/trumpet/1_C2.mp3
// module id = 117
// module chunks = 0